export type LoanType = 'bridging' | 'equityRelease';

// eslint-disable-next-line @typescript-eslint/ban-types
export const debounce = (callback: Function, wait: number) => {
  let timeoutId: number | undefined = undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (...args: any) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(undefined, ...args);
    }, wait);
  };
};
